<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <!-- 顶部 -->
      <div class="header">
        <div class="hd_left" @click="isCity = !isCity">
          <span>{{ city }}</span>
          <img src="../../assets/xia.png" alt="" />
        </div>
        <div class="hd_right">
          <select>
            <option :selected="service == 'All services'">All services</option>
            <option :selected="service == 'Pre-loading / Discharging Survey'">
              Pre-loading / Discharging Survey
            </option>
            <option
              :selected="
                service == 'On/Off Hire Bunker Survey/Bunker &Condition Survey'
              "
            >
              On/Off Hire Bunker Survey/Bunker & Condition Survey
            </option>
            <option :selected="service == 'Bunkering Survey'">
              Bunkering Survey
            </option>
            <option :selected="service == 'Draft Survey'">Draft Survey</option>
            <option :selected="service == 'Insurance Adjust Survey'">
              Insurance Adjust Survey
            </option>
          </select>
          <!-- <input
						type="text"
						v-model="keyword"
						placeholder="Please enter the content"
					/> -->
          <p class="time">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="-"
              start-placeholder="Start"
              end-placeholder="End"
              :editable="false"
              :clearable="false"
              align="center"
              format="MM/dd"
            ></el-date-picker>
          </p>
          <p class="search">
            <img src="../../assets/search.png" alt="" @click="getSearch" />
          </p>
          <span class="shang"></span>
          <span class="xia"></span>
        </div>
      </div>
      <!-- 地区 -->
      <div class="city" v-if="isCity">
        <div class="city-left">
          <span
            :class="{ active: ctIndex == index }"
            v-for="(item, index) in continentList"
            :key="index"
            @click="goContinent(item, index)"
          >
            {{ item.name }}
          </span>
        </div>
        <div class="city-right">
          <div class="li">
            <span
              v-for="(item, index) in countryList"
              :key="index"
              :class="{ active: coIndex == index }"
              @click="goCountry(item, index)"
            >
              {{ item.name }}
            </span>
          </div>
          <p>city</p>
          <div class="li">
            <span
              v-for="(item, index) in cityList"
              :key="index"
              :class="{ active: ciIndex == index }"
              @click="goCity(index)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <ul class="ul">
        <div class="ul-top">
          <select class="item" @change="selectLevel($event)">
            <option>All</option>
            <option>Primary</option>
            <option>Intermediate</option>
            <option>Senior</option>
            <option>Expert</option>
          </select>
          <div class="item" @click="getOrderNum">Order quantity</div>
          <div class="item" @click="getScore">Score</div>
          <div
            style="
              border: 1px solid #00d9dd;
              display: flex;
              height: 40px;
              border-radius: 6px;
            "
          >
            <input
              v-model="key"
              type="text"
              style="background: none; border: none; color: #fff"
            />
            <div
              @click="sousuo"
              style="
                box-shadow: rgb(11, 234, 235) 0px 0px 6px inset;
                height: 100%;
                width: 60px;
                text-align: center;
                line-height: 40px;
              "
            >
              <img
                style="margin-top: 6px"
                src="../../assets/search.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="ul-bottom" style="max-height: 580px; overflow-y: scroll">
          <div
            class="item"
            v-for="(item, index) in jysList"
            :key="index"
            @click="goDetails"
          >
            <img :src="item.icon" />
            <p class="jys">{{ item.serveTitle }}</p>
            <p class="name">{{ item.name }}</p>
            <p class="order">{{ item.counts || 0 }}</p>
            <p class="age">{{ item.workYear }} Year</p>
            <p class="star">{{ item.score }} Branch</p>
            <p class="money">{{ parseInt(item.price) || 0 }}</p>
          </div>
        </div>
        <div
          style="text-align: center; line-height: 100px; color: #fff"
          v-if="jysList.length == 0"
        >
          暂无数据
        </div>
      </ul>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
export default {
  name: "search",
  components: {
    navTop,
    navFooter,
  },
  data() {
    return {
      key: "",
      isCity: false, //地区状态
      continentList: [], //洲
      ctIndex: 0, //洲下标
      continentId: "", //洲id
      countryList: [], //国家
      coIndex: 0, //国家下标
      countryId: "", //国家id
      cityList: [], //城市
      ciIndex: -1, //城市下标
      city: "Work area",
      service: "", //服务
      isSearch: "",
      time: "", //时间
      date: [], //yy-mm-ss
      type: 1, //检验师列表-查询排序
      level: 0, //检验师列表-级别
      jysList: [], //检验师列表
    };
  },
  created() {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      if (this.$route.query.city) {
        this.type = 3;
        this.city = this.$route.query.city;
        this.service = this.$route.query.service;
        this.time = this.$route.query.time;

        this.isSearch = 1;
      } else {
        this.type = 1;
      }
      this.getList();
      this.getAreafirst();
    }
  },
  methods: {
    // 工作地区一级
    getAreafirst() {
      let data = {};
      this.$api.areafirst(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.continentList = res.dataList;
          this.continentId = res.dataList[0].id;
          this.getAreasecond();
        }
      });
    },
    // 工作地区二级
    getAreasecond() {
      let data = {
        id: this.continentId,
      };
      this.$api.areasecond(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.countryList = res.dataList;
          this.countryId = res.dataList[0].id;
          this.getAreathird();
        }
      });
    },
    // 工作地区三级
    getAreathird() {
      let data = {
        id: this.countryId,
      };
      this.$api.areathird(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.cityList = res.dataList;
        }
      });
    },
    // 选择洲
    goContinent(item, i) {
      this.ctIndex = i;
      this.coIndex = 0;
      this.ciIndex = -1;
      this.continentId = item.id;
      this.getAreasecond();
    },
    // 选择国家
    goCountry(item, i) {
      this.coIndex = i;
      this.countryId = item.id;
      this.getAreathird();
    },
    // 选择城市
    goCity(i) {
      this.ciIndex = i;
      this.isCity = false;
      this.city = this.cityList[i].name;
    },
    // 选择级别
    selectLevel(e) {
      console.log(e.target.value);
      this.type = 0;
      this.isSearch = 0;
      if (e.target.value == "Primary") {
        this.level = 0;
      } else if (e.target.value == "Intermediate") {
        this.level = 1;
      } else if (e.target.value == "Senior") {
        this.level = 2;
      } else if (e.target.value == "Expert") {
        this.level = 3;
      } else if (e.target.value == "All") {
        this.level = 4;
      }
      this.getList();
    },
    // 选择订单量
    getOrderNum() {
      this.type = 1;
      this.isSearch = 0;
      this.getList();
    },
    // 选择评分
    getScore() {
      this.type = 2;
      this.isSearch = 0;
      this.getList();
    },
    // 搜索
    getSearch() {
      console.log(this.time, "gggg");
      this.type = 3;
      this.isSearch = 1;
      this.getList();
    },
    // 检验师列表
    getList(istrue) {
      this.date = [];
      this.time.forEach((item) => {
        let a = new Date(item);
        let y = "";
        let r = "";
        if (a.getMonth() + 1 < 10) {
          y = "0" + (a.getMonth() + 1);
        } else {
          y = a.getMonth() + 1;
        }
        if (a.getDate() < 10) {
          r = "0" + a.getDate();
        } else {
          r = a.getDate();
        }
        this.date.push(a.getFullYear() + "-" + y + "-" + r);
      });
      console.log(istrue);
      let data = {
        type: this.type,
        level: this.level,
        workArea: this.city,
        isSearch: this.isSearch,
        startTime: this.date[0],
        endTime: this.date[1],
        nowPage: 1,
        pageCount: 100000,
      };
      if (istrue) {
        data.key = this.key;
      }
      this.$api.list(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.jysList = res.data.list;
        } else {
          this.jysList = [];
        }
      });
    },
    sousuo() {
      if (this.key) {
        this.getList(true);
      } else {
        this.getList(false);
      }
    },
    // 检验师、服务详情
    goDetails() {
      this.$router.push({ path: "/detail" });
    },
  },
};
</script>

<style lang="scss" scoped>
.ul-bottom::-webkit-scrollbar {
  width: 0px;
  /*height: 4px;*/
}
.ul-bottom::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.ul-bottom::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.pages {
  background: #3E414A;
  .box {
    margin-bottom: 90px;
    position: relative;
    // 头部
    .header {
      padding: 25px 0 30px 125px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .hd_left {
        width: 131px;
        height: 35px;
        border: 1px solid #00fcff;
        box-sizing: border-box;
        background: #000103;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          font-size: 20px;
          color: #00fcff;
        }
        img {
          width: 19px;
          height: 10px;
          display: block;
          margin-left: 9px;
        }
      }
      .hd_right {
        height: 40px;
        background-image: url("../../assets/index-header2.png");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        position: relative;
        select {
          width: 140px;
          height: 100%;
          background: rgba(0, 0, 0, 0.1);
          border: none;
          outline: none;
          font-size: 20px;
          font-family: Adobe Heiti Std;
          font-weight: 500;
          color: #00d9dd;
          padding-left: 12px;
          box-sizing: border-box;
          border-right: 1px solid #00d9dd;
          option {
            background: #000;
            color: #00d9dd;
          }
        }
        input {
          width: 281px;
          height: 40px;
          background: #000;
          outline: none;
          border: 1px solid #00d0d4;
          padding: 0 10px;
          box-sizing: border-box;
          font-family: Adobe Heiti Std;
          font-weight: 500;
          font-size: 20px;
          color: #00d9dd;
        }
        .time {
          height: 100%;
          width: 153px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #00cfd4;
          text-align: center;
          line-height: 40px;
          box-sizing: border-box;
          ::v-deep .el-date-editor--daterange {
            width: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #000;
            border: none;
            border-top: 1px solid #00d0d4;
            border-bottom: 1px solid #00d0d4;
            box-sizing: border-box;
            padding: 0;
            .el-input__icon {
              display: none;
            }
            .el-range-input {
              flex: 1;
              background: #000;
              color: #00cfd4;
              font-weight: 500;
              font-size: 20px;
            }
            .el-range-separator {
              padding: 0;
              color: #00cfd4;
              line-height: 40px;
            }
            input::-webkit-input-placeholder {
              color: rgba(19, 255, 252, 1);
            }
            input:-moz-placeholder {
              color: rgba(19, 255, 252, 1);
            }
            input::-moz-placeholder {
              color: rgba(19, 255, 252, 1);
            }
            input::-ms-input-placeholder {
              color: rgba(19, 255, 252, 1);
            }
          }
        }
        .search {
          width: 46px;
          height: 40px;
          box-shadow: 0px 0px 10px 0px #00d9dd inset;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .shang {
          width: 0;
          height: 0;
          border-top: 4px solid #000000;
          border-left: 6px solid transparent;
          position: absolute;
          top: 0;
          right: 0;
        }
        .xia {
          width: 0;
          height: 0;
          border-bottom: 4px solid #000000;
          border-left: 6px solid transparent;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
    }
    // 工作地区
    .city {
      width: 100%;
      box-shadow: 0px 0px 25px 0px rgba(0, 175, 255, 0.4);
      background-image: url("../../assets/city.png");
      background-size: 100% 100%;
      position: absolute;
      top: 82px;
      left: 0px;
      padding: 38px 27px 77px 57px;
      box-sizing: border-box;
      display: flex;
      z-index: 99;
      .city-left {
        display: flex;
        flex-direction: column;
        span {
          width: 96px;
          height: 30px;
          font-size: 21px;
          color: #ffffff;
          text-align: center;
          line-height: 30px;
          margin-bottom: 65px;
          box-sizing: border-box;
        }
        .active {
          background: rgba(0, 252, 255, 0.5);
          border: 1px solid rgba(0, 252, 255, 1);
          box-sizing: border-box;
        }
      }
      .city-right {
        margin-left: 39px;
        .li {
          display: flex;
          flex-wrap: wrap;
          span {
            width: 96px;
            height: 30px;
            font-size: 21px;
            color: #ffffff;
            text-align: center;
            line-height: 30px;
            box-sizing: border-box;
            margin-bottom: 25px;
          }
          .active {
            background: rgba(0, 252, 255, 0.5);
            border: 1px solid rgba(0, 252, 255, 1);
            box-sizing: border-box;
          }
        }
        p {
          font-size: 30px;
          color: #ffffff;
          padding-left: 17px;
          box-sizing: border-box;
          margin-bottom: 32px;
        }
      }
    }
    .ul {
      width: 100%;
      border: 1px solid rgba(0, 250, 255, 0.6);
      border-radius: 35px;
      background: #002127;
      box-shadow: 0px 0px 150px 50px #00343a inset;
      padding: 45px;
      box-sizing: border-box;
      .ul-top {
        padding-left: 8px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .item {
          height: 35px;
          border: 1px solid #00fcff;
          outline: none;
          background: #00282e;
          box-shadow: 0px 0px 5px 2px #00fcff inset;
          font-size: 20px;
          color: #00fcff;
          padding: 0 15px;
          box-sizing: border-box;
          margin-right: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          option {
            background: #000;
            color: #00d9dd;
            font-size: 20px;
          }
          p {
            font-size: 20px;
            color: #00d9dd;
          }
          img {
            width: 15px;
            height: 21px;
            display: block;
          }
        }
        .item:last-child {
          margin-right: 0;
        }
      }
      .ul-bottom {
        padding: 62px 2px 0 0;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .item {
          width: 425px;
          height: 181px;
          background-image: url("../../assets/index-item.png");
          background-size: 100% 100%;
          margin-right: 36px;
          margin-bottom: 78px;
          position: relative;
          img {
            width: 110px;
            height: 110px;
            background: #b7f0ff;
            border-radius: 50%;
            position: absolute;
            top: 35px;
            left: 38px;
          }
          .jys {
            width: 120px;
            height: 21px;
            background: #0a3063;
            border: 1px solid #227ea1;
            border-radius: 11px;
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 21px;
            position: absolute;
            bottom: 34px;
            left: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 14px;
            font-weight: bold;
            color: #83c3d1;
            position: absolute;
            top: 10px;
            left: 220px;
          }
          .order {
            font-size: 14px;
            font-weight: bold;
            color: #83c3d1;
            position: absolute;
            top: 44px;
            left: 220px;
          }
          .age {
            font-size: 14px;
            font-weight: bold;
            color: #83c3d1;
            position: absolute;
            top: 79px;
            left: 226px;
          }
          .star {
            font-size: 14px;
            font-weight: bold;
            color: #83c3d1;
            position: absolute;
            top: 114px;
            left: 223px;
          }
          .money {
            font-size: 14px;
            font-weight: bold;
            color: #83c3d1;
            position: absolute;
            top: 144px;
            left: 220px;
          }
        }
        .item:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
